import React from "react";
import P from "prop-types";
import Tab from "./Tab";
import TabItem from "./TabItem";

const Tabs = ({ base, items }) => (
  <Tab base={base}>
    {items.map(({ title, page }) => (
      <TabItem key={`${page}${title}`} to={page}>{title}</TabItem>
    ))}
  </Tab>
);

Tabs.propTypes = {
  base: P.string.isRequired,
  items: P.arrayOf(
    P.shape({ page: P.string.isRequired, title: P.string.isRequired })
  ).isRequired,
};

export default Tabs;
